import * as constantFilter from './constantFilter'

import * as dataFilters from './dataFilters'
export default {
  ...constantFilter,
  ...dataFilters
}
